import { render, staticRenderFns } from "./bind-goods-modal.vue?vue&type=template&id=d1abb8f2&scoped=true"
import script from "./bind-goods-modal.vue?vue&type=script&lang=js"
export * from "./bind-goods-modal.vue?vue&type=script&lang=js"
import style0 from "./bind-goods-modal.vue?vue&type=style&index=0&id=d1abb8f2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1abb8f2",
  null
  
)

export default component.exports